<script>
  export let className = '';
  export let imageSrc = '';
  export let altText = 'user';
  export let testimonialText = '';
  export let name = '';
  export let designation = '';
</script>

<div class={`flex flex-col items-center ${className}`}>
  <div class="size-16 mb-2.5 rounded-full border border-white overflow-hidden">
    <img class="object-cover size-full" width="64" height="64" src={imageSrc} alt={altText} />
  </div>
  <div class="text-2xl leading-7 italic text-center font-dm-serif">
    {@html testimonialText}
  </div>
  <div class="text-[17px] leading-5 font-light mt-2.5 flex flex-col items-center text-center gap-1">
    <div>– {name}</div>
    <div class="opacity-50">{designation}</div>
  </div>
</div>
